module.exports = __webpack_public_path__ + "img/time-gray.3df0ee57.svg";